import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './auth';
import { ModalProvider } from './modal';
import { ToastProvider } from './toast';
import { TabProvider } from './tab';
import setLinks from '../links';
import { FeedbackProvider } from './feedback';
import { NotificationProvider } from './notifications';
import GlobalErrorListener from '../components/GlobalErrorListener';

const AppProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  setLinks();

  return (
    <BrowserRouter
      future={{
        v7_startTransition: true,
      }}
    >
      <FeedbackProvider>
        <ToastProvider>
          <GlobalErrorListener />
          <AuthProvider>
            <NotificationProvider>
              <ModalProvider>
                <TabProvider>{children}</TabProvider>
              </ModalProvider>
            </NotificationProvider>
          </AuthProvider>
        </ToastProvider>
      </FeedbackProvider>
    </BrowserRouter>
  );
};

export default AppProvider;
